import { subDays } from 'date-fns';

interface DateRangeOption {
  description: string;
  startDate: Date;
  endDate: Date;
}

export function getDateRangeOptions(): DateRangeOption[] {
  const today = new Date();

  return [
    {
      description: 'Hoje',
      startDate: today,
      endDate: today,
    },
    {
      description: 'Ontem',
      startDate: subDays(today, 1),
      endDate: subDays(today, 1),
    },
    {
      description: 'Últimos 7 dias',
      startDate: subDays(today, 7),
      endDate: today,
    },
    {
      description: 'Últimos 30 dias',
      startDate: subDays(today, 30),
      endDate: today,
    },
  ];
}
